import { render } from "./PaymentsModule.vue?vue&type=template&id=0f25005e&ts=true&lang=true"
import script from "./PaymentsModule.vue?vue&type=script&lang=ts"
export * from "./PaymentsModule.vue?vue&type=script&lang=ts"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__